import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { AbstractApiResponse } from '../../shared/models';
import { AbstractApiService } from '../../shared/services';
import { EmailTemplate } from '../models';
import { UserRoleService } from '../../shared/services/user-role.service';

type baseType = EmailTemplate;

@Injectable()
export class EmailTemplateContextsService {
  namespace = '/template_contexts';

  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  readOne(iri: string): Observable<baseType> {
    return this.rolesService.userHasRoleFilter<baseType>(
      'ROLE_MWS_TEMPLATE_CONTEXT_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  readList(): Observable<AbstractApiResponse | any> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_TEMPLATE_CONTEXT_LIST',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(this.namespace)
    );
  }
}
